export default function ListView({
  items = [],
  style,
  listType = "unordered",
}) {
  const renderList = () => {
    return items.map((item, index) => {
      return (
        <li
          key={index}
          style={{
            padding: "4px 6px",
            color: "#4D6767",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // alignItems: "center",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#4D6767",
                width: item?.value ? "80%" : "100%",
                ...style,
              }}
            >
              {typeof item === "object" ? item?.label : item}
            </div>
            {item?.value && (
              <div
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  color: "#004135",
                  // alignSelf: "center",
                  ...style,
                }}
              >
                {item?.value}
              </div>
            )}
          </div>
        </li>
      );
    });
  };

  return listType === "ordered" ? (
    <ol style={{ marginLeft: "15px", padding: 0 }}>{renderList()}</ol>
  ) : (
    <ul style={{ marginLeft: "15px", padding: 0 }}>{renderList()}</ul>
  );
}
